import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  ELIGIBLE_PROMOTIONS_STORE_KEY,
  EligiblePromotionsState,
} from './eligible-promotions.state';

export const selectEligiblePromotionsFeature = createFeatureSelector<EligiblePromotionsState>(
  ELIGIBLE_PROMOTIONS_STORE_KEY,
);

export const selectEligiblePromotionsData = createSelector(
  selectEligiblePromotionsFeature,
  (state: EligiblePromotionsState) => state.data,
);

export const selectEligiblePromotionsIsLoaded = createSelector(
  selectEligiblePromotionsFeature,
  (state: EligiblePromotionsState) => state.isLoaded,
);

export const selectEligiblePromotionsIsLoading = createSelector(
  selectEligiblePromotionsFeature,
  (state: EligiblePromotionsState) => state.isLoading,
);
